<div class="content">
    <div>
        <div><img [title]="appSettings.title" [alt]="appSettings.title" src="assets/images/logo.png" height="150"></div>
        <div class="header">Oops. The page you are looking for does not exist.</div>
    </div>
</div>
